export const NEW = 'New Mortgage'
export const REFINANCE = 'Refinance or Renew'
export const HOME_EQUITY = 'Home Equity Loan'
export const DOES_NOT_OWN_HOME = 'I Do Not Own My Own Home'
export const NEW_PARAM = 'new-mortgage'
export const REFINANCE_PARAM = 'refinance-mortgage'
export const HOME_EQUITY_PARAM = 'home-equity-mortgage'
